import {
  DocumentationModel,
  VersionModel,
} from 'shared/domain/documentation/documentationModel';
import { isUploadStatusSuccess } from 'shared/types/uploadStatus';
import { createdAtSortDesc } from 'helpers/sort';

const isSuccessfullVersion = (
  v: VersionModel
): boolean | string | undefined =>
  isUploadStatusSuccess(v.uploadStatus) || v?.localData;

/**
 * Returns the most recent successfully uploaded version of a documentation.
 * Returns null if no successful version exists.
 */
export function getLastSuccessfullVersion(
  documentation: DocumentationModel
): VersionModel | null {
  const successfullVersions = documentation.versions
    .filter(isSuccessfullVersion)
    .sort(createdAtSortDesc);

  return successfullVersions[0] || null;
}

/**
 * Checks if a documentation has at least one successfully uploaded version.
 */
export function isSuccessUpload(
  documentation: DocumentationModel
): boolean {
  return Boolean(getLastSuccessfullVersion(documentation));
}
